// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"312":"940c3aa4","592":"d12de919","917":"2e2e127f"}[chunkId] || chunkId) + "." + {"93":"cd7fcade6b14868b","233":"44bec0ef79a996af","312":"ba9374fc5fe30027","592":"cdba2ab3ffb0acc4","709":"8cf2490a61b5cbd2","779":"43e36d68aed5c41f","917":"86812664629b566b"}[chunkId] + ".js";
};